import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=0f5bb08e&"
import script from "./InfoBox.vue?vue&type=script&lang=ts&"
export * from "./InfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports